/**
 * 백엔드 경로 상수 — `06-api-spec` 의 실경로. 문자열을 코드 곳곳에 흩지 않는다.
 *
 * ⚠ 타입은 `src/api/schema.ts`(openapi-typescript 생성물)가 정본이다(F §10-2: 실 스키마와
 * 수기 복원 문서의 경로 집합 차이 0 확인). 생성은 `pnpm gen:api` — 백엔드가 떠 있어야 한다.
 * 여기 상수는 그 생성물이 커버하지 못하는 것(경로 조립)만 담당한다.
 */

export const API = {
  // ── 인증(게이트 밖 — /api/v1 접두어가 아니다) ──
  login: '/auth/login',
  logout: '/auth/logout',
  me: '/auth/me',

  // ── 대화 ──
  chatStream: '/api/v1/chat/stream',
  // 사이드바 대화 목록. ⚠ 백엔드에서 이 경로는 `/{thread_id}/...` 보다 먼저 등록돼 있어야 한다.
  threads: '/api/v1/chat/threads',
  transcript: (threadId: string) => `/api/v1/chat/${encodeURIComponent(threadId)}/transcript`,
  artifacts: (threadId: string) => `/api/v1/chat/${encodeURIComponent(threadId)}/artifacts`,

  // ── 프로젝트(F-6) — 대화를 묶는 사용자 작업 공간 ──
  projects: '/api/v1/projects',
  project: (projectId: string) => `/api/v1/projects/${encodeURIComponent(projectId)}`,
  projectThreads: (projectId: string) =>
    `/api/v1/projects/${encodeURIComponent(projectId)}/threads`,
  // 대화의 소속 변경(null=해제). 스트림 바디의 project_id 는 **첫 턴에만** 적용되므로,
  // 이미 시작된 대화를 옮기는 것은 이 경로의 일이다.
  threadProject: (threadId: string) => `/api/v1/chat/${encodeURIComponent(threadId)}/project`,

  // ── 입력 ──
  uploads: '/api/v1/uploads',

  // ── 마스터플랜(B 트랙) ──
  masterplanXlsx: (threadId: string) =>
    `/api/v1/masterplan/${encodeURIComponent(threadId)}/xlsx`,
  masterplanJob: (threadId: string) => `/api/v1/masterplan/${encodeURIComponent(threadId)}/job`,
  masterplanJobCancel: (threadId: string) =>
    `/api/v1/masterplan/${encodeURIComponent(threadId)}/job/cancel`,
  masterplanJobs: '/api/v1/masterplan/jobs',
  // 파일함(B-4) — 산출물 이력. 목록엔 바이트가 없고, 개별 경로만 파일을 흘린다.
  masterplanArtifacts: '/api/v1/masterplan/artifacts',
  masterplanArtifact: (artifactId: string) =>
    `/api/v1/masterplan/artifacts/${encodeURIComponent(artifactId)}/xlsx`,

  // ── WBS(구 경로 — R5 정리 대상이라 이식하지 않는다. 참조용으로만 남긴다) ──
  // wbsXlsx: '/api/v1/wbs/xlsx',

  // ── 관리자(F-4) ──
  adminStatus: '/api/v1/admin/status',
  adminMasters: '/api/v1/admin/masters',
  adminMaster: (kind: string) => `/api/v1/admin/masters/${encodeURIComponent(kind)}`,
  adminAudit: '/api/v1/admin/audit',
  adminUsers: '/api/v1/admin/users',
  // 전사 조회(ADM Phase C) — 세 겹: 집계 / 목록 / 본문. 본문 열람은 서버가 감사에 남긴다.
  adminOversightUsers: '/api/v1/admin/oversight/users',
  adminOversightProjects: '/api/v1/admin/oversight/projects',
  adminOversightThreads: '/api/v1/admin/oversight/threads',
  adminOversightThread: (threadId: string) =>
    `/api/v1/admin/oversight/threads/${encodeURIComponent(threadId)}`,
  adminUserAction: (userId: string, action: 'role' | 'status' | 'password') =>
    `/api/v1/admin/users/${encodeURIComponent(userId)}/${action}`,
} as const
